export const attributesConstants = {
  LOAD_ATTRIBUTES: '[Attributes] Loading attributes',
  LOAD_ATTRIBUTES_FAILURE: '[Attributes] Loading attributes fail',
  LOAD_ATTRIBUTES_DASHBOARD_SUCCESS: '[Attributes] Loading dashboard attributes success',
  LOAD_ATTRIBUTES_DETECTIONS_SUCCESS: '[Attributes] Loading detections attributes success',
  RESET_ATTRIBUTES: '[Attributes] Reset all attributes'
}
